import "./backlink.js";

/**
 * Main navigation.
 */

const menuItems = document.querySelectorAll('.menu-item-has-children');
const menuButtons = document.querySelectorAll('.menu-item button');

menuItems.forEach(item => {
    // Add "open" class on mouseover
    item.addEventListener('mouseover', () => {
        item.classList.add('open');
    });

    // Remove "open" class on mouseleave
    item.addEventListener('mouseleave', () => {
        item.classList.remove('open');
    });
});

menuButtons.forEach(item => {
    // Add "open" class on click
    item.addEventListener('click', () => {
        item.parentElement.classList.toggle('open');
    });
});

/**
 * Open nav when clicking on the burger menu.
 */

const burgerMenu = document.querySelector('#burger');
const mainNav = document.querySelector('#nav');

if (burger && mainNav) {
    burgerMenu.addEventListener('click', () => {
        mainNav.classList.toggle('open');
    });
}

/**
 * Signature.
 */

const consoleStyle = "font-family:monospace;background-color:#3172a1;padding:2px 6px;color:white;border-radius:3px;";
console.log("%cWeb Development", consoleStyle, "https://sebastien.vignol.be");